<label class="headerLabel secondary">
	<mat-icon fontSet="fad" fontIcon="fa-address-card" inline />
	{{ T.CREATE_SESSION_USER_DETAILS_SECTION_HEADING | translate }}
</label>

@if (user()) {
	<div class="infoWrapper content">
		<section class="infoUpper">
			<mat-icon [fontIcon]="typeIcon()" fontSet="fad" />
			<label>
				{{ user().fullname }}
			</label>
			@if (user().email) {
				<mat-chip class="emailChip" [disableRipple]="true">
					{{ user().email }}
				</mat-chip>
			}
		</section>
		<section class="infoLower">
			<label class="secondary">{{ T.LABEL_STUDENT_ID | translate }}</label>
			<span>
				@if (user().isicNumber) {
					{{ user().isicNumber }}
				} @else {
					{{ T.LABEL_NOT_PROVIDED | translate }}
				}
			</span>

			<label class="secondary">{{ T.LABEL_BIRTHDATE | translate }}</label>
			<span>
				@if (user().birthday) {
					{{ user().birthday | date: "dd.MM.yyyy" :'': translate.currentLang }}
				} @else {
					{{ T.LABEL_NOT_PROVIDED | translate }}
				}
			</span>

			<label class="secondary">{{ T.LABEL_GENDER | translate }}</label>
			<span>
				@if (user().gender) {
					@switch (user().gender) {
						@case (Gender.Male) {
							<mat-icon fontSet="far" fontIcon="fa-mars" />
						}
						@case (Gender.Female) {
							<mat-icon fontSet="far" fontIcon="fa-venus" />
						}
						@case (Gender.Other) {
							<mat-icon fontSet="far" fontIcon="fa-genderless" />
						}
					}
					{{ user().gender | enumLabel: EnumLabel.Gender }}
				} @else {
					{{ T.LABEL_NOT_PROVIDED | translate }}
				}
			</span>
		</section>

		<!--CHILDREN-->
		<ng-content select="[extra]" />
		<ng-content select="[actions]" />
	</div>
} @else {
	<div class="emptyState content secondary">
		<mat-icon fontSet="fad" fontIcon="fa-user-slash" />
		<label>{{ T.LABEL_NO_USER_SELECTED | translate }}</label>
	</div>
}
